import { render, staticRenderFns } from "./DataAssetForList.vue?vue&type=template&id=10d00e58&scoped=true"
import script from "./DataAssetForList.vue?vue&type=script&lang=js"
export * from "./DataAssetForList.vue?vue&type=script&lang=js"
import style0 from "./DataAssetForList.vue?vue&type=style&index=0&id=10d00e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d00e58",
  null
  
)

export default component.exports